export const BEESS = "Beess";
export const SPP = "Spp";
export const PTS = "Pts";
